/**
 * 城北街道，家风文明
 */

import axios from "@/utils/request"

export const sumScore = () => {
  return axios.request({
    url: "a2022/tmnc/sum_score",
    method: "GET",
  })
}

export const allPutao = () => {
  return axios.request({
    url: "a2022/tmnc/all_putao",
    method: "GET",
  })
}

export const addLingqu = (data) => {
  return axios.request({
    url: "a2022/tmnc/add_lingqu",
    method: "POST",
    data
  })
}

export const oneLingqu = () => {
  return axios.request({
    url: "a2022/tmnc/one_lingqu",
    method: "GET",
  })
}

export const oneUserScore = () => {
  return axios.request({
    url: "a2022/tmnc/one_user_score",
    method: "GET",
  })
}

export const addScore = (data) => {
  return axios.request({
    url: "a2022/tmnc/add_user_score",
    method: "POST",
    data
  })
}

export const countZhongzhi = () => {
  return axios.request({
    url: "a2022/tmnc/count_zhongzhi",
    method: "GET",
  })
}

export const getPrizeRecord = (params) => {
  return axios.request({
    url: "a2022/tmnc/one_prize_record",
    method: "GET",
    params
  });
};

export const loadPrize = (params) => {
  return axios.request({
    url: "a2022/tmnc/all_prize",
    method: "GET",
    params
  })
}

export const getPrizeRand = (params) => {
  return axios.request({
    url: "a2022/tmnc/prize_rand",
    method: "GET",
    params
  })
}

export const savePrizeWinner = (data) => {
  return axios.request({
    url: "a2022/tmnc/save_user",
    method: "POST",
    data,
  })
}

export const getMyPrize = (params) => {
  return axios.request({
    url: "a2022/tmnc/my_prize",
    method: "GET",
    params
  })
}

export const addPrizeRecord = (data) => {
  return axios.request({
    url: "a2022/tmnc/add_prize_record",
    method: "POST",
    data
  });
};
